export default class BaseBundlerModule {
	protected readonly mode!: RequestMode;

	constructor(mode: RequestMode = 'cors') {
		this.mode = mode;
	}

	private readonly fetchByUrl: (url: string) => Promise<string> = (url) => {
		const throwError = (errorMessage: string) => {
			throw new Error(errorMessage);
		};

		return fetch(url, {
			credentials: 'same-origin',
			mode: this.mode
		})
			.then((response) => (response.ok ? response.text() : throwError('fetch response is not ok')))
			.catch((e) => {
				// eslint-disable-next-line no-console
				console.warn(e);
				return '';
			});
	};

	public fetchUrls<T>(
		urls: Array<string>,
		storage: Map<string, T>,
		createEntity: (value: Promise<string>) => T
	): Array<T> {
		return urls.map((url) => this.addToMap(url, storage, createEntity));
	}

	protected addToMap<T>(url: string, storage: Map<string, T>, createEntity: (value: Promise<string>) => T): T {
		if (!storage.has(url)) {
			const value = this.fetchByUrl(url);
			storage.set(url, createEntity(value));
		}

		return storage.get(url) as T;
	}
}
